import type { FormInstance } from '@arco-design/web-react';

import type { DeployTypeCode } from '../../core/types';
import { SKU_RESOURCE_MODULES_FIELD, hasFormFieldValue } from '../scene-layout';

export type SkuResourceModulesEnricher = (
  data: Record<string, unknown>,
  modules: Record<string, boolean> | undefined,
) => Record<string, boolean> | undefined;

const ENRICHERS: Partial<Record<DeployTypeCode, SkuResourceModulesEnricher>> = {};

export function registerSkuResourceModulesEnricher(code: DeployTypeCode, enricher: SkuResourceModulesEnricher): void {
  ENRICHERS[code] = enricher;
}

/** 从 versioned preset 或裸对象解析 data 层 */
export function parsePresetData(presetConfig?: Record<string, unknown> | string): Record<string, unknown> | undefined {
  if (!presetConfig) return undefined;
  try {
    const parsed = typeof presetConfig === 'string' ? JSON.parse(presetConfig) : presetConfig;
    if (parsed && typeof parsed === 'object' && 'data' in parsed && parsed.data && typeof parsed.data === 'object') {
      return parsed.data as Record<string, unknown>;
    }
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : undefined;
  } catch {
    return undefined;
  }
}

export function extractSkuResourceModulesFromPreset(presetConfig?: Record<string, unknown> | string): Record<string, boolean> | undefined {
  const data = parsePresetData(presetConfig);
  const modules = data?.skuResourceModules;
  if (!modules || typeof modules !== 'object') return undefined;
  return modules as Record<string, boolean>;
}

/** preset hydrate 后恢复 innerForm.skuResourceModules（经插件 enricher 扩展） */
export function hydrateSkuResourceModulesFromPreset(
  deployTypeCode: DeployTypeCode,
  innerForm: FormInstance,
  presetConfig?: Record<string, unknown> | string,
): void {
  const data = parsePresetData(presetConfig);
  let modules = extractSkuResourceModulesFromPreset(presetConfig);
  const enricher = ENRICHERS[deployTypeCode];
  if (enricher && data) {
    modules = enricher(data, modules);
  }
  if (!modules) return;
  innerForm.setFieldValue(SKU_RESOURCE_MODULES_FIELD, modules);
}

export { hasFormFieldValue };
